import { render } from "./PickTextBySwipe.vue?vue&type=template&id=6451d899&scoped=true"
import script from "./PickTextBySwipe.vue?vue&type=script&lang=ts"
export * from "./PickTextBySwipe.vue?vue&type=script&lang=ts"

import "./PickTextBySwipe.vue?vue&type=style&index=0&id=6451d899&lang=less&scoped=true"
import "./PickTextBySwipe.vue?vue&type=style&index=1&id=6451d899&lang=less"
script.render = render
script.__scopeId = "data-v-6451d899"

export default script